/* eslint-disable prettier/prettier */
import moment from 'moment';

export const QUERY = {
  allJobs: (status = 0, search = '', isWarning, filter = {}, singporeJobs = false, country = '', first, offset) => `query MyQuery {
        allJobs(condition: { 
          ${status > 0 ? `status: ${status},` : ``}
          ${country ? `countryId: ${country},` : ``}
          isActive: true 
        }, filter: { 
          ${status === 0 ? `status: { in:[1,2,3,4,6]}` : ``}
          ${isWarning ? `updatedAt: { lessThanOrEqualTo: "${moment().subtract(3, 'days').startOf().toISOString()}"}` : ``}
          and:[
          ${singporeJobs ? `{targetPort:{includesInsensitive:"singapore"}}` : ``}
          ${filter.status ? `{status: { in: ${JSON.stringify(filter.status)}}}` : ``}
          ${filter.createdBy ? `{createdBy: { in: ${JSON.stringify(filter.createdBy)}}}` : ``}
          ${filter.updatedBy ? `{updatedBy: { in: ${JSON.stringify(filter.updatedBy)}}}` : ``}
          ${filter.startDate ? `{queryReceivedOn: { greaterThanOrEqualTo: "${filter.startDate}" }}` : ``}
          ${filter.endDate ? `{queryReceivedOn: { lessThanOrEqualTo: "${filter.endDate}" }}` : ``}
          ${filter.company && filter.company.length > 0 ? `{companyId: {in: ${JSON.stringify(filter.company)}}}` : ``}
          ${filter.engineers && filter.engineers.length > 0 ? `{ mapJobEngineersByJobId: { some: { engineerId: { in: ${JSON.stringify(filter.engineers)} } } } }}` : ``}
          ${filter.jobDescriptions && filter.jobDescriptions.length > 0 ? `{
            mapJobDescriptionsByJobId: { some: { descriptionId: { in: ${JSON.stringify(filter.jobDescriptions)} } } }
          }` : ``}
          ${filter.jobDescriptionsNotIn && filter.jobDescriptionsNotIn.length > 0 ? `{and: ${JSON.stringify(filter.jobDescriptionsNotIn.map(notJd => {
    return `{ mapJobDescriptionsByJobId: { some: { descriptionId: { notEqualTo: ${notJd} } } }}`
  })).replace(/"/g, '')}},` : ``}
          ${filter.onlyJobDescriptions && filter.onlyJobDescriptions.length > 0 ? `{or: ${JSON.stringify(filter.onlyJobDescriptions.map(jd => {
    return `{ mapJobDescriptionsByJobId: { every: { descriptionId: { equalTo: ${jd} } } } },`
  })).replace(/"/g, '')}},` : ``}
          ${filter.descriptions && filter.descriptions.length > 0 ? `{description: {in: ${JSON.stringify(filter.descriptions)}}}` : ``}
          ${filter.shipNames && filter.shipNames.length > 0 ? `{shipName: { in: ${JSON.stringify(filter.shipNames)} }}` : ``}
          ${filter.targetPorts && filter.targetPorts.length > 0 ? `{targetPort: { in: ${JSON.stringify(filter.targetPorts)} }}` : ``}
          ${filter.targetPortsNotIn && filter.targetPortsNotIn.length > 0 ? `{targetPort: { notIn: ${JSON.stringify(filter.targetPortsNotIn)} }}` : ``}
          ${filter.boxVesselClass && filter.boxVesselClass.length > 0 ? `{boxVesselClass: { in: ${JSON.stringify(filter.boxVesselClass)} }}` : ``}
          ${filter.vesselETA ? `{vesselETA: { lessThanOrEqualTo: "${filter.vesselETA.startOf('day').toISOString()}" }}` : ``}
          ${filter.vesselETA ? `{vesselETA: { greaterThanOrEqualTo: "${filter.vesselETA.startOf('day').toISOString()}" }}` : ``}
          ${filter.isFollowupReq ? `{isFollowupReq: { equalTo: ${filter.isFollowupReq} }}` : ``}
          ${filter.sparePrepared !== undefined ? `{sparesPrepare: { equalTo: ${filter.sparePrepared} }}` : ``}
          ${filter.spareVerify ? `{sparesVerified: { equalTo: ${filter.spareVerify} }}` : ``}
          ${filter.nextAttendDate ? `{nextAttendDate: { isNull: false }}` : ``}
          ${filter.invoiceDate ? `{invoiceDate: { isNull: false }}` : ``}
          ${filter.vdcCocReport ? `{vdcCocReport: { equalTo: "[]" }}` : ``}
          ]
          or: [
            { jobCode: { includesInsensitive: "${search?.trim() ?? ''}" } }
            { boxVesselClass: { includesInsensitive: "${search?.trim() ?? ''}" } }
            { shipName: { includesInsensitive: "${search?.trim() ?? ''}" } }
            { description: { includesInsensitive: "${search?.trim() ?? ''}" } }
            { equipmentDetail: { includesInsensitive: "${search?.trim() ?? ''}" } }
            { equipmentModal: { includesInsensitive: "${search?.trim() ?? ''}" } }
            { poNumber: { includesInsensitive: "${search?.trim() ?? ''}" } }
            { targetPort: { includesInsensitive: "${search?.trim() ?? ''}" } }
          ]
        }, orderBy: CREATED_AT_DESC,
        ${first ? `first: ${parseInt(first)},` : ``}
        ${offset !== null || offset !== undefined ? `offset: ${offset * first},` : ``}
          ){
          totalCount
          pageInfo {
              hasNextPage
          }
          nodes {
            id
            jobCode
            queryReceivedOn
            quotationDate
            shipName
            sparesPrepare
            sparesVerified
            spares
            description
            country
            countryId
            country_id:countryId
            masterCountryByCountryId{
              id
              countryName
            }
            companyByCompanyId {
              companyName
            }
            mapJobDescriptionsByJobId {
              nodes {
                descriptionId
                masterDescriptionByDescriptionId {
                  descriptionName
                }
              }
            }
            targetPort
            vesselEta
            userProfileByUpdatedBy{
              firstName
            }
            updatedAt
            poNumber
            description
            setReminder
            mapJobSparesByJobId {
              nodes {
                spareId
                masterSpareBySpareId {
                  name
                }
              }
            }
            mapJobEngineersByJobId {
              nodes {
                engineerId
                engineerByEngineerId {
                  firstName
                }
              }
            }
            agentId
            agentByAgentId{
              firstName
              mobile
            }
            isJobCompleted
            completionDate
            isServiceReportSent
            invoiceDate
            invoice
            isFollowupReq
            serviceReport
            nextAttendDate
            accountantNote
            engineerNote
            generalNote
            boxVesselClass
            equipmentDetail
            equipmentModal
            generalNoteAttachments
            engineerNoteAttachments
            status
            vdcCocReport
            masterJobStatusByStatus {
              statusName
            }
            userProfileByCreatedBy {
              firstName
              lastName
            }
            userProfileByUpdatedBy {
              firstName
              lastName
            }
          }
        }
      }
      `,
  getStats: `
  query MyQuery {
    query:allJobs(condition: {status: 1, isActive: true}) {
      count:totalCount
    }
    quoted:allJobs(condition: {status: 2, isActive: true}) {
      count:totalCount
    }
    orderConfirmed: allJobs(
      condition: { status: 3, isActive: true },
      filter: {
        and: [ 
        {mapJobDescriptionsByJobId:{ some:{ descriptionId:{ notEqualTo: 23 } } }},
        {mapJobDescriptionsByJobId:{ some:{ descriptionId:{ notEqualTo: 73 } } }}
        ]
      }
    ) {
      count: totalCount
    }
    warning: allJobs(
        condition: { isActive: true }
        filter: { and: [ {status:{ in:[1,2] }}, {updatedAt: { lessThanOrEqualTo: "${moment().subtract(3, 'days').startOf().toISOString()}"} }] }
      ) {
        count: totalCount
    }
    magneticCompassCalibration: allJobs(
    condition: { status: 3, isActive: true }
    filter: {
      or: [
        {
          mapJobDescriptionsByJobId: {
            every: { descriptionId: { equalTo: 23 } }
          }
        },
        {
          mapJobDescriptionsByJobId: {
            every: { descriptionId: { equalTo: 73 } }
          }
        },
      ]
    }
  ) {
    count: totalCount
  }
    jobCompleted:allJobs(condition: {status: 4, isActive: true}) {
      count:totalCount
    }
    invoiceSent:allJobs(condition: {status: 6, isActive: true}, filter: {
      targetPort: {notIn: ${JSON.stringify(["Singapore", "singapore", "SINGAPORE", "Malaysia", "MALAYSIA", "malaysia"])}}
    }){
      count:totalCount
    }
    logistics:allJobs(condition: {status: 6, isActive: true}, filter:{
      targetPort:{
        in: ["Singapore", "singapore", "SINGAPORE","Malaysia", "MALAYSIA", "malaysia"]
      }
    }) {
      count:totalCount
    }
    liveJobs:allJobs(condition: {isActive: true}, filter:{status:{in:[1,2,3,4,6]}}) {
      count:totalCount
    }
    jobCancelled:allJobs(condition: {status: 5, isActive: true}) {
      count:totalCount
    }
    jobHistory:allJobs(condition: {isActive: true}, filter:{isFollowupReq:{equalTo:true},nextAttendDate:{isNull:false}}) {
      count:totalCount
    }
  }
  `,
  getJob: (id = "") => {
    return `
    query MyQuery {
      jobById(id: "${id}") {
        id
        jobCode
        spares
        sparesPrepare
        sparesVerified
        queryReceivedOn
        quotationDate
        shipname:shipName
        company:companyId
        companyByCompanyId {
          companyName
        }
        mapJobDescriptionsByJobId {
          nodes {
            descriptionId
            masterDescriptionByDescriptionId {
              descriptionName
            }
          }
        }
        mapJobEngineersByJobId {
          nodes {
            engineerId
            engineerByEngineerId {
              firstName
            }
          }
        }
        targetPort
        vesselETA:vesselEta
        poNumber
        description
        setReminder
        mapJobSparesByJobId {
          nodes {
            spareId
            masterSpareBySpareId {
              name
            }
          }
        }
        agentId
        agentByAgentId{
          firstName
          mobile
        }
        isJobCompleted
        completionDate
        isServiceReportSent
        invoiceDate
        invoice
        isFollowupReq
        serviceReport
        nextAttendDate
        accountantNote
        engineerNote
        generalNote
        boxVesselClass
        equipmentDetail
        equipmentModal
        generalNoteAttachments
        engineerNoteAttachments
        status
        country
        countryId
        country_id:countryId
        masterCountryByCountryId{
          id
          countryName
        }
        vdcCocReport
        masterJobStatusByStatus {
          statusName
        }
        userProfileByCreatedBy {
          firstName
          lastName
        }
        userProfileByUpdatedBy {
          firstName
          lastName
        }
      }
    }
    `
  },
  getFilterData: `
  query MyQuery {
    allJobs(condition:{isActive:true}){
      nodes{
        shipName
        targetPort
        description
        boxVesselClass
      }
    }
  }
  `,
  cancelJob: (id = '') => {
    return `mutation MyMutation {
      updateJobById(input: {jobPatch: {status: 5}, id: "${id}"}) {
        clientMutationId
      }
    }`
  },
  deleteJob: (ids = []) => {
    return `mutation MyMutation {
      ${ids.map((id, index) => `deleteJob${index}:updateJobById(input: {jobPatch: {status: 5}, id: "${id}"}) {
        clientMutationId
      }`)}
    }`
  }
};
